export enum EStatuses {
	JOIN = 'join',
	NOT_JOINED = 'not_joined',
	JOINED = 'joined',
	REJECTED = 'rejected',
	VERIFICATION = 'verification',
}
